import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ep6gjj3v9q: FaireBrandEntity = {
  token: "b_ep6gjj3v9q",
  type: "brand",
  name: "Branded By Barta",
  avatarUrl:
    "https://cdn.faire.com/fastly/c5f742b2618e67c18a99d85b5829a76c63504adc7457126491c439fb7e0eb63f.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b2246e38a1fdd9c7e38efd23a8447dbf7165898e2a4866d8f7d1a79c3cb37c5c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c5f742b2618e67c18a99d85b5829a76c63504adc7457126491c439fb7e0eb63f.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b2246e38a1fdd9c7e38efd23a8447dbf7165898e2a4866d8f7d1a79c3cb37c5c.png",
  location: "Lytle, TX, USA",
  minimumOrderDollars: 75,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Welcome to Branded By Barta! We are a small family owned business specializing in graphic tees. We print all dtf transfers in house. Our goal is to bring you the perfect cute + comfy + affordable graphic tees that your customers will love. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:46.591Z",
    importedBy: "entity-db-cli",
  },
};
